import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import storeReducer from './slices/storeSlice';
import performanceReducer from './slices/performanceSlice';

const store = configureStore({
    reducer: {
        auth: authReducer,
        store: storeReducer,
        performance: performanceReducer,
    },
});

export default store;
